// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"0":"cb3d65093e1b0a13fecb","794":"9b17648d9903e3ac2e8a","924":"5555db4140e0163ad973","926":"bddf44710bee9ac65dfe"}[chunkId] + ".js";
};